import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import * as fromStore from '../../../../store';
import tabs from './ai-bulder-pages-tabs.json';
import {FormControl} from "@angular/forms";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {Website} from "../../website";
import {Observable} from "rxjs";
import {IAIBuilderPage} from "./ai-builder-pages-table/ai-builder-pages-table.component";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../user/user-subscription";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {combineLatest} from "rxjs";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {ActivityAction, ActivityStatus, IActivity} from "../../../../activities/activity";
import {Subject} from "rxjs";
import {Product} from "../../product";
import {OneMonthFreeComponent} from "../../../../shared/components/dialogs/one-month-free/one-month-free.component";
import {DbModalService} from "../../../../modules/modal/modal";
import {Location} from "@angular/common";
import {ConfirmDialogComponent} from "../../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {WorkspaceService} from "../../../../workspace/workspace.service";
import {Payment} from "../../../../user/payment";
import {User} from "../../../../user/user";
import features from "./ai-builder-features.json";
import {Config} from "../../../../config/config";
import {CookieService} from "ngx-cookie";
import {UserService} from "../../../../user/user.service";
import {Utils} from "../../../../shared/utils/utils";
import {UserSubscriptionStatus} from "../../../../user/user-subscription-status";
import {GlobalEvent} from "../../../../shared/services/global-event-dispatcher/global-event";
import {
  GlobalEventDispatcherService
} from "../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {TextUtils} from "../../../../shared/utils/text-utils";

interface ITab {
  id: 'pages' | 'header' | 'footer' | 'single' | 'archive' | 'slide' | string;
  label: string;
}
enum RegenerateOptions {
  outline_from_scratch,
  use_old_outline
}

@Component({
    selector: 'db-ai-builder-pages',
    templateUrl: './ai-builder-pages.component.html',
    styleUrls: ['./ai-builder-pages.component.scss'],
    standalone: false
})
export class AiBuilderPagesComponent implements OnInit, OnDestroy {

  @Input() builderPlugin?: Product;
  @Input() pagesLimit: number;
  @Input() canGenerateWebsites: boolean = true;
  @Output() onRecreate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRegenerate: EventEmitter<any> = new EventEmitter<any>();

  public website: Website;
  public user: User;
  public userLocalStorage: any = {};
  public userSubscription: UserSubscription;
  public choosenPlan: any;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public createdPagesLoading$: Observable<boolean>;
  public searchTerm: FormControl;
  public tabs: ITab[] = tabs;
  public activeTab: ITab['id'] = tabs[0].id;
  public heads: string[] = ['Title', 'Link', 'Last modified', 'Status', 'Edit'];
  public templateHeads: string[] = ['Title', 'Condition', 'Last modified', 'Status', 'Edit'];
  public templateSlidesHeads: string[] = ['Title', 'Last modified', 'Status', 'Edit'];
  public pages: IAIBuilderPage[] | null = null;
  public aiBuilderCreatedPages: IAIBuilderPage[] | null = null;
  public hasFrontPage: boolean = true;
  public onlyTrials: boolean;
  public kitPage: any = null;
  public kitData: any = null;
  public disableAddPage: boolean;
  public ongoingBuilderActivity$: Observable<IActivity>;
  public homePage: IAIBuilderPage;
  public paidClient: boolean;
  public regenerationCount: number = 0;
  public websiteTenWebTheme: Product | null;
  public payments: Payment[];
  public isMobile: boolean;
  public features: string[] = features;
  public demoUser: boolean = false;
  public Config = Config;
  public previewUrl: string = '';

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  private _interrupt$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _modalService: DbModalService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _router: Router,
    private _userService: UserService,
    private _cookieService: CookieService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _dialogService: DialogService,
    private _workspaceService: WorkspaceService,
    private _globalEventDispatcher: GlobalEventDispatcherService
  ) {
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 991;
    this.website = this._route.snapshot.parent.data['website'];
    this.userSubscription = this._route.snapshot.parent.data['userSubscription'];
    this.createdPagesLoading$ = this._store.select(fromStore.getCreatedPagesLoading(this.website.id));
    this.searchTerm = new FormControl('');
    this.user = this._route.snapshot.parent.data['user'];
    this.userLocalStorage = this._route.snapshot.parent.data['userLocalStorage'];
    this.demoUser = Utils.isDemoUser(this.userSubscription, this.user);
    this.onlyTrials = this.userSubscription && ((this.userSubscription.trialClient && this.demoUser) || this.userSubscription.trialBoosterClient
      || this.userSubscription.freeBaseClient || this.userSubscription.trialOptimizerClient);
    this.paidClient = [this.UserSubscriptionCategory.PLATFORM, UserSubscriptionType.ONE_PRODUCT, UserSubscriptionType.PREMIUM, this.UserSubscriptionCategory.PLATFORM, this.UserSubscriptionCategory.DedicatedVM,  UserSubscriptionType.BOOSTER].includes(this.userSubscription.type)
      || (this.userSubscription?.trialClient && !this.demoUser);
    const dbTesting = !!this._cookieService.get('db-testing');
    this.previewUrl = this.demoUser ? `${this.website.site_url}?from=sidebar&client_id=${this.user?.id}&domain_id=${Config.demoDomainId}&first_time` + (!!dbTesting ? `&db-testing` : ``) : this.website.site_url;
    const queryParams: any = (<any>this._route.queryParams).value;
    const showUpgradePopup = queryParams.showUpgradePopup;
    const showRegeneratePopup = queryParams.showRegeneratePopup;
    const currentOutline = queryParams.currentOutline === RegenerateOptions.use_old_outline;
    const step = queryParams.step || null;
    const subscr_id = queryParams.subscr_id || null;
    const themeId = queryParams.theme_id || null;
    const fontFamily = queryParams.font_family || null;
    const colorPallet = queryParams.color_pallet || null;
    if (!TypeUtils.isNull(themeId) || !TypeUtils.isNull(fontFamily) || !TypeUtils.isNull(colorPallet)) {
      this.updateUserLocalStorage(themeId, fontFamily, colorPallet);
    }

    if (!TypeUtils.isNull(subscr_id)) {
      this._getChoosedSubscription(subscr_id, showUpgradePopup, step);
    } else {
      showUpgradePopup && !this._modalService.hasOpenModals() && this.showCheckoutUpgradeDialog(step, null);
    }
    showRegeneratePopup && !this._modalService.hasOpenModals() && this.handleClick(true, currentOutline);
    this._initData();
    this._getTenWebTheme();
    this.ongoingActivities();
  }

  openIframe(value) {
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {showIframe: true, iframeUrl: value});
  }

  private updateUserLocalStorage(themeId, fontFamily, colorPallet): void {
    themeId && (this.userLocalStorage['themeId'] = themeId);
    fontFamily && (this.userLocalStorage['fontFamily'] = fontFamily);
    colorPallet && (this.userLocalStorage['colorPallet'] = colorPallet);
    this._userService.setToLocal(this.userLocalStorage);
  }

  private _getChoosedSubscription(subscr_id, showUpgradePopup, step): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserAvailableSubscription(parseInt(subscr_id, 10), true))),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        if (userSubscription) {
          this.choosenPlan = {
            id: userSubscription.id,
            title: userSubscription.plan.title,
            price: userSubscription.plan.planPrice,
            type: userSubscription.plan.periodNumber === 1 ? 'month' : 'year',
          };
          showUpgradePopup && !this._modalService.hasOpenModals() && this.showCheckoutUpgradeDialog(step, this.choosenPlan);
        }
      });
  }

  private _initData(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first(loaded => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
          this._store.select(fromStore.getCreatedPages(this.website.id)),
          this._store.select(fromStore.getRegenerationCount(this.website.id)),
          this._store.select(fromStore.getPayments)
        )),
        takeUntil(this._destroyStream$),
      )
      .subscribe(([user, userSubscription, pages, count, payments]) => {
        this.user = user;
        this.userSubscription = userSubscription;
        this.demoUser = Utils.isDemoUser(userSubscription, user);
        this.paidClient = this.userSubscription && [this.UserSubscriptionCategory.PLATFORM, UserSubscriptionType.ONE_PRODUCT, UserSubscriptionType.PREMIUM, this.UserSubscriptionCategory.PLATFORM, this.UserSubscriptionCategory.DedicatedVM , UserSubscriptionType.BOOSTER].includes(this.userSubscription.type)
        || (this.userSubscription?.trialClient && !this.demoUser);
        this.onlyTrials = this.userSubscription && ((this.userSubscription.trialClient && this.demoUser) || this.userSubscription.trialBoosterClient
          || this.userSubscription.freeBaseClient || this.userSubscription.trialOptimizerClient);
        this.regenerationCount = count;
        this.aiBuilderCreatedPages = pages.filter(page => page.templateType && page.createdWith && ['twbb_recreated', 'twbb_generated', 'twbb_imported'].includes(page.createdWith) && page.pageType === 'page');
        this._getPagesList(pages);
        this.payments = payments;
      });

  }

  private _getPagesList(pages): void {
    if (pages && TypeUtils.isDefined(pages) && !TypeUtils.isEmpty(pages)) {
      this.pages = pages.filter((page) => page && page.pageType === 'page');
      const frontPage = pages.find(page => page && !!page.frontPage);
      this.hasFrontPage = !!frontPage;
      this.homePage = frontPage;
      const kitPage = pages.find(page => page && !TypeUtils.isNull(page.kitPage));
      this._createKitData(frontPage && frontPage.link, kitPage && kitPage.kitPage, kitPage && kitPage.kitSettings);
    }
  }

  private _createKitData(frontPage, kitPage, kitSettings): void {
    const kitData = [];
    kitData.push({front_page: frontPage || {}, is_ai_kit: kitPage || false, kit_settings: kitSettings || {}});
    this.kitData = kitData[0];
    const addPage = new URL(window.location.href).searchParams.get("add_page");
    const fromDemo = new URL(window.location.href).searchParams.get("from_demo");
    const menuTermId = new URL(window.location.href).searchParams.get("menu_term_id");
    const menuItemId = new URL(window.location.href).searchParams.get("menu_item_id");
    const menuItemPosition = new URL(window.location.href).searchParams.get("menu_item_position");
    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
    addPage && ((this.onlyTrials && this.aiBuilderCreatedPages && this.aiBuilderCreatedPages.length >= this.pagesLimit) ? this.showCheckoutInfoDialog() : this.addPage(true, true, menuTermId, menuItemId, menuItemPosition));
  }

  public addPage(fromSite: boolean, hasMenuItem: boolean, menuTermId?, menuItemId?, menuItemPosition?): void {
    if (hasMenuItem) {
      this.onRecreate.emit({kitData: this.kitData, hasFrontPage: this.hasFrontPage, menuTermId, menuItemId, menuItemPosition});
    }
    else {
      this.onRecreate.emit({kitData: this.kitData, hasFrontPage: this.hasFrontPage});
    }
  }

  public ongoingActivities(): void {
    this._store.select(fromStore.getOngoingActivity)
      .pipe(
        takeUntil(this._destroyStream$ || this._interrupt$),
        filter(activity => activity && activity.websiteId === this.website.id)
      )
      .subscribe(activity => {
        if ((activity.action === 'install_template' || activity.action === 'install_hosted_template')) {
          if (activity.status === ActivityStatus.RUNNING) {
            this.disableAddPage = true;
          } else if (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED) {
            this.disableAddPage = false;
          }
        }
      });
  }

  public setActiveTab(tabId: string): void {
    this.activeTab = tabId as ITab['id'];
  }

  public showCheckoutInfoDialog(): void {
    const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
    modal.componentInstance.mode = 'builder';
  }

  public handleClick(isRegenerateFromDemo: boolean = false, currentOutline = false): void {
    if (!this.canGenerateWebsites) {
      if (this.demoUser) {
        return this.showCheckoutUpgradeDialog(2, null);
      }
  /*    else if (this.userSubscription && this.userSubscription.type === UserSubscriptionType.FREE) {
        const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
        modal.componentInstance.mode = 'editor';
        return;
      }*/ else {
        return this.showExceededDialog();
      }
    }
    if (!this.websiteTenWebTheme && !this.demoUser) {
      this.showConfirmInstallDialog();
    } else {
      this.onRegenerate.emit({isRegenerateFromDemo, currentOutline});
    }
  }

  public showExceededDialog(): void {
    this._dialogService
      .addDialog(ConfirmDialogComponent, {
        header: TextUtils.getText('text_youExceededTheLimitForAiGenerations'),
        message: this.userSubscription && this.userSubscription.category !== UserSubscriptionCategory.ENTERPRISE ? TextUtils.getText('text_upgradeToHigherPlanToGetMoreAiGenerations') : TextUtils.getText('text_youExceededTheLimitForAiGenerationsDesc'),
        confirmButtonText: this.userSubscription && this.userSubscription.category !== UserSubscriptionCategory.ENTERPRISE ? TextUtils.getText('text_upgrade') : TextUtils.getText('text_contactUsTitle'),
        confirmButtonClass: 'ds-btn-blue ds-btn-s m rectangle',
        cancelButtonText: TextUtils.getText('text_cancel'),
        cancelButtonClass: 'ds-btn-white-gray-border white-bg ds-btn-s m short',
        alignLeft: true,
        fromStaging: true,
        hasCloseButton: false,
        width: '700px',
        height: '186px'
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          if (this.userSubscription && this.userSubscription.category === UserSubscriptionCategory.ENTERPRISE) {
            this.openChat();
          } else if (this.userSubscription && this.userSubscription
            .status === UserSubscriptionStatus.canceled) {
            this._router.navigate(['/workspace/subscription-plan']);
          }  else {
            this._router.navigate(['/upgrade-plan']);
          }
        }
      });
  }

  private openChat() {
    /*window['zE']('messenger', 'chat:removeTags', ['generic_support']);
    window['zE']('messenger', 'chat:addTags', ['open_livechat']);*/

    window['Smooch']?.open();
    /*window['zE']('messenger', 'chat:send', 'Get more AI generations');*/
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

  public showConfirmInstallDialog(): void {
    this._dialogService
      .addDialog(ConfirmDialogComponent, {
        header: 'Generate content<br/> and images with AI',
        message: '10Web builder theme will be installed<br/> automatically during generation.<br/> Your website will be replaced with a new one.',
        confirmButtonText: 'Got It',
        confirmButtonClass: 'ds-btn-blue'
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.installAndActivate();
          this.onRegenerate.emit();
        }
      });
  }

  public showCheckoutUpgradeDialog(step?, plan?): void {
    const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
    modal.componentInstance.mode = 'editor';
    modal.componentInstance.mixed = this.demoUser;
    if (step && +step === 2) {
      modal.componentInstance.step = 'plans';
    }
    if (!TypeUtils.isNull(plan)) {
      modal.componentInstance.chosenPlan = plan;
    }
  }

  private _getTenWebTheme(): void {
    this._store.select(fromStore.getWebsiteTenWebTheme(this.website.id))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(websiteTenWebTheme => !!websiteTenWebTheme),
      )
      .subscribe(websiteTenWebTheme => this.websiteTenWebTheme = websiteTenWebTheme);
  }

  public installAndActivate(): any {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.websiteTenWebTheme],
      action: !this.websiteTenWebTheme.installed ? ActivityAction.INSTALL_ACTIVATE : ActivityAction.ACTIVATE,
      network: 1
    }));
  }


  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this._interrupt$.next(true);
    this._interrupt$.complete();
  }
}
